<template>
  <div class="wechatPrivateMessageIndex">
    <!-- 自定义胶囊式tab切换栏（使用子组件） -->
     <div style="margin: 20px 0 0 20px;">
 <CustomTabs
      :tabs="tabs"
      :activeTab="activeTab"
      @tabChange="handleTabClick"
    />
     </div>
   
    <privateMessageChat
      :sessionList="sessionList"
      @filter-click="handleFilter"
      @session-select="handleSessionSelect"
      @star-change="handleStarChange"
      @add-click="handleAdd"
      @message-send="handleMessageSend"
    />
  </div>
</template>
<script>
export default {
  name: "wechatPrivateMessageIndex",
  data() {
    return {
      activeTab: "keyword",
      // 标签页数据
      tabs: [
        { label: "近期私信", value: "keyword" },
        { label: "已收藏私信", value: "follow" },
      ],
      sessionList: [
        {
          id: 1,
          name: "戚文浩",
          avatar: "/static/avatar1.png",
          lastMsg: "高祖刘邦，沛县丰邑中阳里人，汉朝开国皇帝，汉民族...",
          time: "1小时前",
          unread: 0,
          starred: false,
          messages: [
            {
              type: "left",
              content:
                "故国神游，多情应笑我，早生华发。人生如梦，一尊还酹江月。",
            },
            {
              type: "right",
              content:
                "故国神游，多情应笑我，早生华发。人生如梦，一尊还酹江月。",
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleFilter() {
      console.log("Filter clicked");
    },
    handleSessionSelect(session) {
      console.log("Selected session:", session);
    },
    handleStarChange(item) {
      console.log("Star changed:", item);
    },
    handleAdd() {
      console.log("Add clicked");
    },
    handleMessageSend(data) {
      console.log("Message sent:", data);
    },
    handleTabClick(button) {
      console.log("父组件接收点击tab", button);
      this.activeTab = button;
    },
  },
};
</script>
<style lang="scss" scoped>
.wechatPrivateMessageIndex {
  height: 100%;
}
</style>
